export enum ProjectMode {
  LITE = 'lite',
  POWER = 'power'
}

/**
 * Project visibility/access control
 * Determines whether content protection is required
 */
export enum ProjectVisibility {
  PUBLIC = 'public',
  PRIVATE = 'private'
}

/**
 * Response from syncing environment variables to dev container
 * Used when applying connections and secrets changes
 */
export interface SyncEnvironmentResponse {
  success: boolean;
  connectionsCount: number;
  secretsCount: number;
  message?: string;
  error?: string;
}